import { z } from 'zod/v4';

export const studentFormSchema = z.object({
  kind: z.literal('student'),
});

type StudentFormValues = z.infer<typeof studentFormSchema>;

export const defaultStudentFormValues: StudentFormValues = {
  kind: 'student',
};

// There is no need for a component for the student form, because it has no additional fields
